export const DEFAULT_DOMAINS = [
	'aol.com',
	'gmail.com',
	'yahoo.com',
	'hotmail.com',
	'live.com',
	'outlook.com',
	'icloud.com',
	'hey.com',
]
